import {Role} from '../backend/interfaces/role';
import {PostRole} from '../backend/requests/post-role';
import {PutRole} from '../backend/requests/put-role';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';
import {PaginatedArrayResponse} from './interfaces/paginated-array-response';

export class RolesRepository {
  // Singleton Instance
  private static _instance: RolesRepository;

  // Private
  private logger: Logger;

  static get instance(): RolesRepository {
    if (!this._instance) {
      this._instance = new RolesRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('RolesRepository');
  }

  // Get all roles that a target entity has
  public async getRoles(
    entityId: string,
    limit: number,
    skip: number
  ): Promise<PaginatedArrayResponse<Role>> {
    const response = await BackendApiManager.instance.get<Role[]>(
      `/entities/${entityId}/roles?limit=${limit}&skip=${skip}&localize=true`
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers['x-total-count'] || '', 10),
    };
  }

  // Get an Entity Role by Id
  public async getRole(entityId: string, roleId: string): Promise<Role> {
    const response = await BackendApiManager.instance.get<Role>(
      `/entities/${entityId}/roles/${roleId}`
    );
    return response.data;
  }

  // Creates a new entity role
  public async createRole(entityId: string, body: PostRole): Promise<Role> {
    const response = await BackendApiManager.instance.post<Role>(
      `/entities/${entityId}/roles`,
      body
    );

    return response.data;
  }

  // Updates an entity role
  public async updateRole(entityId: string, roleId: string, body: PutRole): Promise<Role> {
    const response = await BackendApiManager.instance.put<Role>(
      `/entities/${entityId}/roles/${roleId}`,
      body
    );

    return response.data;
  }

  // Deletes an entity role
  public async deleteRole(entityId: string, roleId: string): Promise<void> {
    await BackendApiManager.instance.delete<void>(`/entities/${entityId}/roles/${roleId}`);
  }
}
